import CreatePasswordFormContainer from "./CreatePasswordForm.container";
import { ICreatePasswordFormProps } from "./CreatePasswordForm.types";
import React from "react";

const CreatePasswordForm: React.FC<ICreatePasswordFormProps> = props => (
  <CreatePasswordFormContainer {...props} />
);

export default CreatePasswordForm;
